import { render, staticRenderFns } from "./FmBtnDemo.vue?vue&type=template&id=3bead47e&scoped=true&"
import script from "./FmBtnDemo.vue?vue&type=script&lang=js&"
export * from "./FmBtnDemo.vue?vue&type=script&lang=js&"
import style0 from "./FmBtnDemo.vue?vue&type=style&index=0&id=3bead47e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bead47e",
  null
  
)

export default component.exports